
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getRankList } from '../api/index';

Vue.use(List);
@Component
export default class RecordList extends Vue {
  @Prop() api!: string;
  @Prop() conf!: any;
  @Prop() date!: string;
  loading = false;
  finished = false;
  page = 1;
  listData: any = [];
  loadingStatus = true;

  created() {
    this.onLoad();
  }
  onLoad() {
    console.log('onload加载');
    if (this.loadingStatus) {
      this.loadingStatus = false;
      setTimeout(() => {
        getRankList(this.date, this.page).then((res) => this.handleData(res));
      }, 150);
    }
  }
  handleData(res: any) {
    if (res.msg === '暂无数据' || res.code === 500) {
      this.finished = true;
      console.log('数据请求完成！');
    } else {
      console.log('排行榜数据', res.data.rank);
      this.listData = [...this.listData, ...res.data.rank];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
    console.log('当前loading', this.loading);
  }
  getLocalTime(nS: number | string): string {
    const date = new Date(parseInt(nS.toString(), 10) * 1000);
    const year = date.getFullYear();
    const month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const m =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const s =
      date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

    return `${year}/${month}/${day} ${h}:${m}:${s}`;
  }
  // 转换时间
  transformDate(t: any) {
    return `${Math.floor(t / 60)} '${((t % 60) / 100).toFixed(2).slice(-2)}"`;
  }
  @Watch('date')
  onDateChange() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.listData = [];
    this.onLoad();
  }
}
